import { t, Trans } from '@lingui/macro'
import { BizWidget } from '../widgets/BizWidget'
import { Link } from 'react-router-dom'

export function BizChangeCreditCardAcceptedRoute() {
  return (
    <BizWidget
      title={t`Credit card change successful`}
      bodyClassName="grid gap-4"
    >
      <p>
        <Trans>
          The credit card change was successful. Your next renewal will be
          charged to this card.
        </Trans>
      </p>
      <Link className="link" to="../..">
        <Trans>Back to business settings</Trans>
      </Link>
    </BizWidget>
  )
}
